import m from 'mithril';
import { ThemeManager } from 'mithril-materialized';
ThemeManager.initialize();
document.documentElement.dataset.mmPreset = 'compact-minimal';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    if (import.meta.env.PROD) {
      navigator.serviceWorker
        .register('./sw.js', { updateViaCache: 'none' })
        .then((registration) => {
          console.log('ServiceWorker registered:', registration.scope);
          window.addEventListener('focus', () => {
            registration.update().catch((error) => console.error('ServiceWorker update failed:', error));
          });
        })
        .catch((error) => {
          console.error('ServiceWorker registration failed:', error);
        });
      return;
    }

    // Avoid stale cached assets during local development.
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
    console.log(`ServiceWorkers unregistered in dev: ${registrations.length}`);
  });
}
import 'material-icons/iconfont/filled.css';
import 'mithril-materialized/index.css';
import 'mithril-materialized/presets/compact-minimal.css';
import 'mithril-markdown-wysiwyg/css';
import './css/style.css';
import { routingSvc } from './services/routing-service';
import { Languages, i18n } from './services';
import { LANGUAGE, SAVED } from './utils';
import { registerTemplatePromptPlugin } from './utils/template-prompt-plugin';

registerTemplatePromptPlugin();

export const AllLanguages = {
  en: { name: 'English', fqn: 'en-UK' },
  nl: { name: 'Nederlands', fqn: 'nl-NL', default: true },
  fr: { name: 'Français', fqn: 'fr-FR' },
  de: { name: 'Deutsch', fqn: 'de-DE' },
  es: { name: 'Español', fqn: 'es-ES' },
  pl: { name: 'Polski', fqn: 'pl-PL' },
};

window.onbeforeunload = (e) => {
  if (localStorage.getItem(SAVED) === 'true') return;
  localStorage.setItem(SAVED, 'true');
  e.preventDefault(); // This is necessary for older browsers
  // e.returnValue = ''; // For modern browsers
};

i18n.addOnChangeListener((locale: string) => {
  console.log(`Language loaded`);
  routingSvc.init();
  m.route(document.body, routingSvc.defaultRoute, routingSvc.routingTable());
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        if (!registration.active) throw new Error('No active service worker');
        registration.active.postMessage({ type: 'CACHE_STARTER_KIT', language: locale });
      })
      .catch((error) => console.error('Could not request starter kit cache:', error));
  }
});
i18n.init(
  AllLanguages,
  (window.localStorage.getItem(LANGUAGE) || 'nl') as Languages,
);
